import { IonContent, IonPage } from "@ionic/react";
import React, { useContext, useEffect } from "react";

import {
  Context,
  fetchCareerSheets,
  fetchCareerFeedbackQuestionsHistories,
  fetchCareerChallengeSheets,
  fetchCareerChallengeComments,
} from "../../../store/student";
import LoginHeader from "../../../organisms/LoginHeader";
import CareerAnswerHistory from "../../../templates/CareerAnswerHistory";
import styles from "../common.module.scss";

const CareerAnswerHistoryPage = () => {
  const { dispatch } = useContext(Context);

  useEffect(() => {
    dispatch(fetchCareerSheets());
    dispatch(fetchCareerChallengeComments());
    dispatch(fetchCareerFeedbackQuestionsHistories());
    dispatch(fetchCareerChallengeSheets());
  }, [dispatch]);

  return (
    <IonPage>
      <LoginHeader title="今までの回答" unreadNotiCount={0} />
      <IonContent className={styles.wrapper}>
        <div className={styles.container}>
          <CareerAnswerHistory />
        </div>
      </IonContent>
    </IonPage>
  );
};

export default CareerAnswerHistoryPage;
